const locations = [
  {
    "name": "Amcal+ Chadstone",
    "state": "VIC",
    "lat": -37.886547,
    "lng": 145.083104,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Amcal%2B%20Chadstone%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Amcal+ Northland (Ultra Beauty)",
    "state": "VIC",
    "lat": -37.739899,
    "lng": 145.028249,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Amcal%2B%20Northland%20(Ultra%20Beauty)%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Abbotsford The Hive",
    "state": "VIC",
    "lat": -37.809371,
    "lng": 144.995661,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Abbotsford%20The%20Hive%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Acacia Ridge",
    "state": "QLD",
    "lat": -27.575637,
    "lng": 153.026128,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Acacia%20Ridge%2C%20QLD%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Adelaide - Pulteney Street",
    "state": "SA",
    "lat": -34.92246,
    "lng": 138.605374,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Adelaide%20-%20Pulteney%20Street%2C%20SA%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Adelaide Gouger Street",
    "state": "SA",
    "lat": -34.930533,
    "lng": 138.597074,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Adelaide%20Gouger%20Street%2C%20SA%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Adelaide Myer Centre",
    "state": "SA",
    "lat": -34.922674,
    "lng": 138.600934,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Adelaide%20Myer%20Centre%2C%20SA%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Adelaide Street Brisbane",
    "state": "QLD",
    "lat": -27.467243,
    "lng": 153.026849,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Adelaide%20Street%20Brisbane%2C%20QLD%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Airport West (Ultra Beauty)",
    "state": "VIC",
    "lat": -37.71382,
    "lng": 144.885691,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Airport%20West%20(Ultra%20Beauty)%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Albury",
    "state": "NSW",
    "lat": -36.081827,
    "lng": 146.917883,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Albury%2C%20NSW%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Alexandria",
    "state": "NSW",
    "lat": -33.902267,
    "lng": 151.196471,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Alexandria%2C%20NSW%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Alfredton",
    "state": "VIC",
    "lat": -37.555622,
    "lng": 143.817673,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Alfredton%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Altona - Pier Street",
    "state": "VIC",
    "lat": -37.868151,
    "lng": 144.830127,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Altona%20-%20Pier%20Street%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Altona Gate Shopping Centre",
    "state": "VIC",
    "lat": -37.828003,
    "lng": 144.847255,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Altona%20Gate%20Shopping%20Centre%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Altona North",
    "state": "VIC",
    "lat": -37.834882,
    "lng": 144.847265,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Altona%20North%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Annerley",
    "state": "QLD",
    "lat": -27.512194,
    "lng": 153.031218,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Annerley%2C%20QLD%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Armadale Forrest Road GP Clinic",
    "state": "WA",
    "lat": -32.153474,
    "lng": 116.007862,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Armadale%20Forrest%20Road%20GP%20Clinic%2C%20WA%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Armadale Shopping City",
    "state": "WA",
    "lat": -32.154237,
    "lng": 116.014922,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Armadale%20Shopping%20City%2C%20WA%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Artarmon",
    "state": "NSW",
    "lat": -33.809131,
    "lng": 151.184958,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Artarmon%2C%20NSW%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Ascot Vale",
    "state": "VIC",
    "lat": -37.772866,
    "lng": 144.927222,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Ascot%20Vale%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Ascot Vale Union Road",
    "state": "VIC",
    "lat": -37.779885,
    "lng": 144.914531,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Ascot%20Vale%20Union%20Road%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Ashby",
    "state": "WA",
    "lat": -31.731805,
    "lng": 115.80346,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Ashby%2C%20WA%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Ashfield",
    "state": "NSW",
    "lat": -33.888311,
    "lng": 151.123617,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Ashfield%2C%20NSW%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Ashford",
    "state": "SA",
    "lat": -34.947859,
    "lng": 138.578551,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Ashford%2C%20SA%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Ashgrove",
    "state": "QLD",
    "lat": -27.445059,
    "lng": 152.99319,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Ashgrove%2C%20QLD%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Aspley Homemaker City",
    "state": "QLD",
    "lat": -27.35492,
    "lng": 153.018238,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Aspley%20Homemaker%20City%2C%20QLD%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Athelstone",
    "state": "SA",
    "lat": -34.871139,
    "lng": 138.701498,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Athelstone%2C%20SA%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Avalon",
    "state": "NSW",
    "lat": -33.636172,
    "lng": 151.32957,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Avalon%2C%20NSW%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Bairnsdale",
    "state": "VIC",
    "lat": -37.829462,
    "lng": 147.612344,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Bairnsdale%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Balaclava",
    "state": "VIC",
    "lat": -37.868588,
    "lng": 144.992886,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Balaclava%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Ballajura City Shopping Centre",
    "state": "WA",
    "lat": -31.840005,
    "lng": 115.89607,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Ballajura%20City%20Shopping%20Centre%2C%20WA%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Ballarat East",
    "state": "VIC",
    "lat": -37.559428,
    "lng": 143.885181,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Ballarat%20East%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Ballarat Health Co",
    "state": "VIC",
    "lat": -37.533762,
    "lng": 143.815255,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Ballarat%20Health%20Co%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Balmain Darling St",
    "state": "NSW",
    "lat": -33.857137,
    "lng": 151.18069,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Balmain%20Darling%20St%2C%20NSW%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Balwyn",
    "state": "VIC",
    "lat": -37.813024,
    "lng": 145.081901,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Balwyn%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Bankstown",
    "state": "NSW",
    "lat": -33.918662,
    "lng": 151.033501,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Bankstown%2C%20NSW%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Bankstown Home Co",
    "state": "NSW",
    "lat": -33.93206,
    "lng": 151.029676,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Bankstown%20Home%20Co%2C%20NSW%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Baxter (Ultra Beauty)",
    "state": "VIC",
    "lat": -38.184837,
    "lng": 145.141328,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Baxter%20(Ultra%20Beauty)%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Bay Park Plaza",
    "state": "NSW",
    "lat": -31.428155,
    "lng": 152.89705,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Bay%20Park%20Plaza%2C%20NSW%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Bayside SC Frankston",
    "state": "VIC",
    "lat": -38.141333,
    "lng": 145.123897,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Bayside%20SC%20Frankston%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Beaumont Hills",
    "state": "NSW",
    "lat": -33.6984,
    "lng": 150.941301,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Beaumont%20Hills%2C%20NSW%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Beenleigh",
    "state": "QLD",
    "lat": -27.715922,
    "lng": 153.202562,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Beenleigh%2C%20QLD%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Beenleigh River Rd",
    "state": "QLD",
    "lat": -27.7136,
    "lng": 153.189064,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Beenleigh%20River%20Rd%2C%20QLD%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Belconnen Markets - Ibbott Lane",
    "state": "NSW",
    "lat": -31.253218,
    "lng": 146.921099,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Belconnen%20Markets%20-%20Ibbott%20Lane%2C%20NSW%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Belmont",
    "state": "WA",
    "lat": -31.956517,
    "lng": 115.929745,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Belmont%2C%20WA%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Belmore",
    "state": "NSW",
    "lat": -33.915686,
    "lng": 151.087433,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Belmore%2C%20NSW%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Benalla",
    "state": "VIC",
    "lat": -36.551512,
    "lng": 145.983822,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Benalla%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Bendigo",
    "state": "VIC",
    "lat": -36.763174,
    "lng": 144.282903,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Bendigo%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Bentleigh",
    "state": "VIC",
    "lat": -37.918293,
    "lng": 145.039273,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Bentleigh%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Bentley Plaza",
    "state": "WA",
    "lat": -32.001331,
    "lng": 115.920302,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Bentley%20Plaza%2C%20WA%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Bentley Village SC",
    "state": "QLD",
    "lat": -17.005786,
    "lng": 145.742291,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Bentley%20Village%20SC%2C%20QLD%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Bethania",
    "state": "QLD",
    "lat": -27.704251,
    "lng": 153.158308,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Bethania%2C%20QLD%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Birallee Village SC",
    "state": "VIC",
    "lat": -36.12779,
    "lng": 146.864665,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Birallee%20Village%20SC%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Birkenhead Point SC",
    "state": "NSW",
    "lat": -33.855283,
    "lng": 151.162668,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Birkenhead%20Point%20SC%2C%20NSW%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Blacktown",
    "state": "NSW",
    "lat": -33.769499,
    "lng": 150.906538,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Blacktown%2C%20NSW%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Bondi Beach",
    "state": "NSW",
    "lat": -33.890099,
    "lng": 151.274717,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Bondi%20Beach%2C%20NSW%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Bondi Junction",
    "state": "NSW",
    "lat": -33.892057,
    "lng": 151.247578,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Bondi%20Junction%2C%20NSW%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Boorooma",
    "state": "NSW",
    "lat": -35.075433,
    "lng": 147.358271,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Boorooma%2C%20NSW%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Botany",
    "state": "NSW",
    "lat": -33.944572,
    "lng": 151.196104,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Botany%2C%20NSW%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Box Hill",
    "state": "VIC",
    "lat": -37.819533,
    "lng": 145.120617,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Box%20Hill%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Box Hill Central",
    "state": "VIC",
    "lat": -37.819533,
    "lng": 145.120617,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Box%20Hill%20Central%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Box Hill South - Home Co. DC",
    "state": "VIC",
    "lat": -37.837823,
    "lng": 145.133163,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Box%20Hill%20South%20-%20Home%20Co.%20DC%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Brandon Park",
    "state": "VIC",
    "lat": -37.906142,
    "lng": 145.161794,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Brandon%20Park%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Braybrook Home Co",
    "state": "VIC",
    "lat": -37.778195,
    "lng": 144.850905,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Braybrook%20Home%20Co%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Brighton",
    "state": "VIC",
    "lat": -37.905614,
    "lng": 145.004232,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Brighton%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Brisbane",
    "state": "QLD",
    "lat": -27.470123,
    "lng": 153.024137,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Brisbane%2C%20QLD%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Brisbane Queen St",
    "state": "QLD",
    "lat": -27.469341,
    "lng": 153.025445,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Brisbane%20Queen%20St%2C%20QLD%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Broadmeadows",
    "state": "VIC",
    "lat": -37.679777,
    "lng": 144.919462,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Broadmeadows%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Brookvale",
    "state": "NSW",
    "lat": -33.765697,
    "lng": 151.269294,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Brookvale%2C%20NSW%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Brookwater",
    "state": "QLD",
    "lat": -27.663939,
    "lng": 152.891578,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Brookwater%2C%20QLD%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Brown Plains - Home Co.",
    "state": "QLD",
    "lat": -27.66333,
    "lng": 153.063475,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Brown%20Plains%20-%20Home%20Co.%2C%20QLD%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Browns Plains",
    "state": "QLD",
    "lat": -27.66333,
    "lng": 153.063475,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Browns%20Plains%2C%20QLD%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Brunswick",
    "state": "VIC",
    "lat": -37.767265,
    "lng": 144.961802,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Brunswick%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Brunswick South",
    "state": "VIC",
    "lat": -37.775086,
    "lng": 144.960889,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Brunswick%20South%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Buderim",
    "state": "QLD",
    "lat": -26.671763,
    "lng": 153.084882,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Buderim%2C%20QLD%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Bulleen Plaza",
    "state": "VIC",
    "lat": -37.765458,
    "lng": 145.09226,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Bulleen%20Plaza%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Bundaberg",
    "state": "QLD",
    "lat": -24.866222,
    "lng": 152.34998,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Bundaberg%2C%20QLD%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Bundaberg Kensington SC",
    "state": "QLD",
    "lat": -24.890758,
    "lng": 152.320466,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Bundaberg%20Kensington%20SC%2C%20QLD%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Bundoora",
    "state": "VIC",
    "lat": -37.694354,
    "lng": 145.060062,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Bundoora%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Burleigh Waters",
    "state": "QLD",
    "lat": -28.099307,
    "lng": 153.424915,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Burleigh%20Waters%2C%20QLD%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Burns Bay Road Lane Cove",
    "state": "NSW",
    "lat": -33.814764,
    "lng": 151.167128,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Burns%20Bay%20Road%20Lane%20Cove%2C%20NSW%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Burnside",
    "state": "VIC",
    "lat": -37.758625,
    "lng": 144.75367,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Burnside%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Burwood",
    "state": "NSW",
    "lat": -33.871088,
    "lng": 151.104725,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Burwood%2C%20NSW%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Burwood Central",
    "state": "NSW",
    "lat": -33.87538,
    "lng": 151.103755,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Burwood%20Central%2C%20NSW%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Burwood South",
    "state": "NSW",
    "lat": -33.871088,
    "lng": 151.104725,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Burwood%20South%2C%20NSW%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Burwood VIC",
    "state": "VIC",
    "lat": -37.850553,
    "lng": 145.095087,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Burwood%20VIC%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Butler - Home Co.",
    "state": "WA",
    "lat": -31.638319,
    "lng": 115.692779,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Butler%20-%20Home%20Co.%2C%20WA%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Caboolture",
    "state": "QLD",
    "lat": -27.084561,
    "lng": 152.979242,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Caboolture%2C%20QLD%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Caboolutre - Big Fish Junction",
    "state": "QLD",
    "lat": -27.042005,
    "lng": 152.974429,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Caboolutre%20-%20Big%20Fish%20Junction%2C%20QLD%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Cairns",
    "state": "QLD",
    "lat": -16.923342,
    "lng": 145.772269,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Cairns%2C%20QLD%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Caloundra",
    "state": "QLD",
    "lat": -26.794641,
    "lng": 153.103905,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Caloundra%2C%20QLD%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Camberwell",
    "state": "VIC",
    "lat": -37.831348,
    "lng": 145.058822,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Camberwell%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Campbellfield DC",
    "state": "VIC",
    "lat": -37.686883,
    "lng": 144.956649,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Campbellfield%20DC%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Campbelltown (Ultra Beauty)",
    "state": "NSW",
    "lat": -34.071763,
    "lng": 150.804067,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Campbelltown%20(Ultra%20Beauty)%2C%20NSW%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Campsie - Beamish St",
    "state": "NSW",
    "lat": -33.912181,
    "lng": 151.104268,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Campsie%20-%20Beamish%20St%2C%20NSW%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Cannington",
    "state": "WA",
    "lat": -32.017868,
    "lng": 115.934038,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Cannington%2C%20WA%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Cannington South",
    "state": "WA",
    "lat": -32.024611,
    "lng": 115.93997,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Cannington%20South%2C%20WA%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Cannon Hill",
    "state": "QLD",
    "lat": -27.471086,
    "lng": 153.098239,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Cannon%20Hill%2C%20QLD%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Cannon Hill Kmart Plaza",
    "state": "QLD",
    "lat": -27.471086,
    "lng": 153.098239,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Cannon%20Hill%20Kmart%20Plaza%2C%20QLD%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Capalaba",
    "state": "QLD",
    "lat": -27.520909,
    "lng": 153.193181,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Capalaba%2C%20QLD%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Capalaba Park Shopping Centre",
    "state": "QLD",
    "lat": -27.523248,
    "lng": 153.190974,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Capalaba%20Park%20Shopping%20Centre%2C%20QLD%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Capestone Village SC",
    "state": "QLD",
    "lat": -27.233516,
    "lng": 153.038484,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Capestone%20Village%20SC%2C%20QLD%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Caringbah",
    "state": "NSW",
    "lat": -34.042521,
    "lng": 151.120894,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Caringbah%2C%20NSW%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Carlingford",
    "state": "NSW",
    "lat": -33.777845,
    "lng": 151.052176,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Carlingford%2C%20NSW%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Carnegie",
    "state": "VIC",
    "lat": -37.884897,
    "lng": 145.058271,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Carnegie%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Caroline Springs",
    "state": "VIC",
    "lat": -37.755547,
    "lng": 144.740878,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Caroline%20Springs%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Caroline Springs Town Square",
    "state": "VIC",
    "lat": -37.755547,
    "lng": 144.740878,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Caroline%20Springs%20Town%20Square%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Carseldine",
    "state": "QLD",
    "lat": -27.333586,
    "lng": 153.010121,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Carseldine%2C%20QLD%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Casey Central",
    "state": "VIC",
    "lat": -38.066547,
    "lng": 145.300349,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Casey%20Central%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Castle Hill",
    "state": "NSW",
    "lat": -33.730205,
    "lng": 151.016799,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Castle%20Hill%2C%20NSW%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Castle Hill - Hills Super Centre",
    "state": "NSW",
    "lat": -33.726437,
    "lng": 150.976682,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Castle%20Hill%20-%20Hills%20Super%20Centre%2C%20NSW%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Castle Towers",
    "state": "NSW",
    "lat": -33.730548,
    "lng": 151.006784,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Castle%20Towers%2C%20NSW%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Casuarina",
    "state": "NT",
    "lat": -12.375843,
    "lng": 130.87976,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Casuarina%2C%20NT%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Casula DC",
    "state": "NSW",
    "lat": -33.959477,
    "lng": 150.882917,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Casula%20DC%2C%20NSW%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Central South Morang",
    "state": "VIC",
    "lat": -37.649035,
    "lng": 145.074121,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Central%20South%20Morang%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Chadstone Distribution Centre",
    "state": "VIC",
    "lat": -37.89308,
    "lng": 145.091826,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Chadstone%20Distribution%20Centre%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Chadstone Homemaker Centre",
    "state": "VIC",
    "lat": -37.879745,
    "lng": 145.092098,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Chadstone%20Homemaker%20Centre%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Chadstone Shopping Centre (Ultra Beauty)",
    "state": "VIC",
    "lat": -37.887156,
    "lng": 145.085267,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Chadstone%20Shopping%20Centre%20(Ultra%20Beauty)%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Charlestown (Ultra Beauty)",
    "state": "NSW",
    "lat": -32.962758,
    "lng": 151.695645,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Charlestown%20(Ultra%20Beauty)%2C%20NSW%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Chatswood",
    "state": "NSW",
    "lat": -33.795631,
    "lng": 151.184856,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Chatswood%2C%20NSW%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Chatswood Central",
    "state": "NSW",
    "lat": -33.796495,
    "lng": 151.181832,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Chatswood%20Central%2C%20NSW%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Chatswood East",
    "state": "NSW",
    "lat": -33.79229,
    "lng": 151.195207,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Chatswood%20East%2C%20NSW%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Cheltenham",
    "state": "VIC",
    "lat": -37.966134,
    "lng": 145.055693,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Cheltenham%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Chermside",
    "state": "QLD",
    "lat": -27.385027,
    "lng": 153.030211,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Chermside%2C%20QLD%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Chirnside Park (Ultra Beauty)",
    "state": "VIC",
    "lat": -37.757162,
    "lng": 145.313574,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Chirnside%20Park%20(Ultra%20Beauty)%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Clayton",
    "state": "VIC",
    "lat": -37.927939,
    "lng": 145.118851,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Clayton%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Clontarf",
    "state": "QLD",
    "lat": -27.259898,
    "lng": 153.080718,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Clontarf%2C%20QLD%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Clovelly Park",
    "state": "SA",
    "lat": -34.995108,
    "lng": 138.574292,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Clovelly%20Park%2C%20SA%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Cobram Village",
    "state": "VIC",
    "lat": -35.920155,
    "lng": 145.647697,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Cobram%20Village%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Coburg Market",
    "state": "VIC",
    "lat": -37.743742,
    "lng": 144.96579,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Coburg%20Market%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Coburns Central Shopping Centre",
    "state": "VIC",
    "lat": -37.685331,
    "lng": 144.566778,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Coburns%20Central%20Shopping%20Centre%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Collingwood",
    "state": "VIC",
    "lat": -37.801744,
    "lng": 144.98401,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Collingwood%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Colonnades Shopping Centre",
    "state": "SA",
    "lat": -35.141261,
    "lng": 138.494335,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Colonnades%20Shopping%20Centre%2C%20SA%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Coolalinga Central",
    "state": "NT",
    "lat": -12.520983,
    "lng": 131.041101,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Coolalinga%20Central%2C%20NT%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Coolangatta",
    "state": "QLD",
    "lat": -28.16835,
    "lng": 153.536211,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Coolangatta%2C%20QLD%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Corio",
    "state": "VIC",
    "lat": -38.065569,
    "lng": 144.382743,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Corio%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Corio Central SC",
    "state": "VIC",
    "lat": -38.075657,
    "lng": 144.35595,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Corio%20Central%20SC%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Cornubia",
    "state": "QLD",
    "lat": -27.673225,
    "lng": 153.212587,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Cornubia%2C%20QLD%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Cottesloe",
    "state": "WA",
    "lat": -32.003899,
    "lng": 115.760111,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Cottesloe%2C%20WA%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Craigieburn",
    "state": "VIC",
    "lat": -37.583088,
    "lng": 144.919844,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Craigieburn%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Craigieburn Junction",
    "state": "VIC",
    "lat": -37.592439,
    "lng": 144.909012,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Craigieburn%20Junction%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Cranbourne Home Co",
    "state": "VIC",
    "lat": -38.086953,
    "lng": 145.279923,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Cranbourne%20Home%20Co%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Cranbourne Park",
    "state": "VIC",
    "lat": -38.109475,
    "lng": 145.28254,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Cranbourne%20Park%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Cranbourne Springhill SC",
    "state": "VIC",
    "lat": -38.084838,
    "lng": 145.291305,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Cranbourne%20Springhill%20SC%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Crestmead",
    "state": "QLD",
    "lat": -27.685673,
    "lng": 153.093475,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Crestmead%2C%20QLD%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Crows Nest",
    "state": "NSW",
    "lat": -33.826335,
    "lng": 151.200601,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Crows%20Nest%2C%20NSW%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Croydon Central",
    "state": "VIC",
    "lat": -37.793495,
    "lng": 145.27929,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Croydon%20Central%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Croydon Civic Square",
    "state": "VIC",
    "lat": -37.793495,
    "lng": 145.27929,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Croydon%20Civic%20Square%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Dandenong",
    "state": "VIC",
    "lat": -37.987417,
    "lng": 145.213814,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Dandenong%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Dandenong - Princes Highway",
    "state": "VIC",
    "lat": -37.983199,
    "lng": 145.214006,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Dandenong%20-%20Princes%20Highway%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Darlinghurst",
    "state": "NSW",
    "lat": -33.878559,
    "lng": 151.214016,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Darlinghurst%2C%20NSW%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Darwin",
    "state": "NT",
    "lat": -12.460874,
    "lng": 130.841656,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Darwin%2C%20NT%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Darwin - Mitchell Street",
    "state": "NT",
    "lat": -12.463743,
    "lng": 130.839772,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Darwin%20-%20Mitchell%20Street%2C%20NT%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Darwin GPO",
    "state": "NT",
    "lat": -12.460874,
    "lng": 130.841656,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Darwin%20GPO%2C%20NT%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Dee Why",
    "state": "NSW",
    "lat": -33.752624,
    "lng": 151.289194,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Dee%20Why%2C%20NSW%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Derrimut",
    "state": "VIC",
    "lat": -37.784142,
    "lng": 144.771435,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Derrimut%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Docklands",
    "state": "VIC",
    "lat": -37.812269,
    "lng": 144.939224,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Docklands%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Doncaster",
    "state": "VIC",
    "lat": -37.787624,
    "lng": 145.132139,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Doncaster%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Double Bay",
    "state": "NSW",
    "lat": -33.877564,
    "lng": 151.244345,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Double%20Bay%2C%20NSW%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Dubbo (Ultra Beauty)",
    "state": "NSW",
    "lat": -32.248311,
    "lng": 148.601785,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Dubbo%20(Ultra%20Beauty)%2C%20NSW%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Durack",
    "state": "NT",
    "lat": -12.480205,
    "lng": 130.970708,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Durack%2C%20NT%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Eaglehawk",
    "state": "VIC",
    "lat": -36.745916,
    "lng": 144.258286,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Eaglehawk%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Earlwood",
    "state": "NSW",
    "lat": -33.926652,
    "lng": 151.126292,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Earlwood%2C%20NSW%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Eastlands Shopping Centre",
    "state": "TAS",
    "lat": -42.867677,
    "lng": 147.367258,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Eastlands%20Shopping%20Centre%2C%20TAS%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Eastwood",
    "state": "NSW",
    "lat": -33.791523,
    "lng": 151.080731,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Eastwood%2C%20NSW%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Echuca",
    "state": "VIC",
    "lat": -36.14938,
    "lng": 144.731178,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Echuca%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Edgecliff (Ultra Beauty)",
    "state": "NSW",
    "lat": -33.879139,
    "lng": 151.236432,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Edgecliff%20(Ultra%20Beauty)%2C%20NSW%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Elizabeth",
    "state": "SA",
    "lat": -34.718603,
    "lng": 138.667786,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Elizabeth%2C%20SA%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Elizabeth St Victoria Market",
    "state": "VIC",
    "lat": -37.804928,
    "lng": 144.959249,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Elizabeth%20St%20Victoria%20Market%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Ellenbrook Home Co",
    "state": "WA",
    "lat": -31.777962,
    "lng": 115.964199,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Ellenbrook%20Home%20Co%2C%20WA%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Elsternwick (Ultra Beauty)",
    "state": "VIC",
    "lat": -37.884672,
    "lng": 145.002429,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Elsternwick%20(Ultra%20Beauty)%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Eltham Village SC",
    "state": "VIC",
    "lat": -37.714547,
    "lng": 145.14892,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Eltham%20Village%20SC%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Elwood",
    "state": "VIC",
    "lat": -37.872495,
    "lng": 144.989479,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Elwood%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Emerald Hills",
    "state": "NSW",
    "lat": -33.995484,
    "lng": 150.79105,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Emerald%20Hills%2C%20NSW%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Epping - Oxford Street",
    "state": "NSW",
    "lat": -33.77131,
    "lng": 151.083039,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Epping%20-%20Oxford%20Street%2C%20NSW%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Epping Homemaker Centre",
    "state": "VIC",
    "lat": -37.655199,
    "lng": 145.022728,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Epping%20Homemaker%20Centre%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Epping VIC",
    "state": "VIC",
    "lat": -37.655199,
    "lng": 145.022728,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Epping%20VIC%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Epsom Village",
    "state": "VIC",
    "lat": -36.70429,
    "lng": 144.318596,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Epsom%20Village%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Erina",
    "state": "NSW",
    "lat": -33.439411,
    "lng": 151.394874,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Erina%2C%20NSW%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Erina The Entrance Road",
    "state": "NSW",
    "lat": -33.435316,
    "lng": 151.388247,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Erina%20The%20Entrance%20Road%2C%20NSW%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Ermington",
    "state": "NSW",
    "lat": -33.806839,
    "lng": 151.070159,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Ermington%2C%20NSW%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Essendon",
    "state": "VIC",
    "lat": -37.75527,
    "lng": 144.918746,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Essendon%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Essendon DFO",
    "state": "VIC",
    "lat": -37.75527,
    "lng": 144.918746,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Essendon%20DFO%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Eve Central SC",
    "state": "VIC",
    "lat": -38.072913,
    "lng": 145.315982,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Eve%20Central%20SC%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Fairfield NSW",
    "state": "NSW",
    "lat": -33.870656,
    "lng": 150.953689,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Fairfield%20NSW%2C%20NSW%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Fairfield VIC",
    "state": "VIC",
    "lat": -37.776396,
    "lng": 145.018218,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Fairfield%20VIC%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Ferntree Gully",
    "state": "VIC",
    "lat": -37.888223,
    "lng": 145.289989,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Ferntree%20Gully%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse First Health Medical Rowville",
    "state": "VIC",
    "lat": -37.919475,
    "lng": 145.235281,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20First%20Health%20Medical%20Rowville%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Fitzroy",
    "state": "VIC",
    "lat": -37.801382,
    "lng": 144.97808,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Fitzroy%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Five Dock",
    "state": "NSW",
    "lat": -33.86955,
    "lng": 151.129103,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Five%20Dock%2C%20NSW%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Footscray",
    "state": "VIC",
    "lat": -37.799248,
    "lng": 144.897963,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Footscray%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Forest Glen",
    "state": "QLD",
    "lat": -26.687995,
    "lng": 153.007624,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Forest%20Glen%2C%20QLD%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Forest Hill",
    "state": "VIC",
    "lat": -37.841629,
    "lng": 145.171844,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Forest%20Hill%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Forest Hill Brentford Square",
    "state": "VIC",
    "lat": -37.836588,
    "lng": 145.184889,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Forest%20Hill%20Brentford%20Square%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Fortitude Valley",
    "state": "QLD",
    "lat": -27.453675,
    "lng": 153.039565,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Fortitude%20Valley%2C%20QLD%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Fountain Gate",
    "state": "VIC",
    "lat": -38.02501,
    "lng": 145.306055,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Fountain%20Gate%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Frankston",
    "state": "VIC",
    "lat": -38.14304,
    "lng": 145.12349,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Frankston%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Fremantle",
    "state": "WA",
    "lat": -32.052224,
    "lng": 115.74832,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Fremantle%2C%20WA%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Fyshwick",
    "state": "ACT",
    "lat": -35.336123,
    "lng": 149.179921,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Fyshwick%2C%20ACT%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Garbutt",
    "state": "QLD",
    "lat": -19.268254,
    "lng": 146.767845,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Garbutt%2C%20QLD%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Gateway Shopping Centre",
    "state": "NT",
    "lat": -12.469265,
    "lng": 130.980162,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Gateway%20Shopping%20Centre%2C%20NT%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Gawler Place Adelaide",
    "state": "SA",
    "lat": -34.92315,
    "lng": 138.601036,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Gawler%20Place%20Adelaide%2C%20SA%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Geelong",
    "state": "VIC",
    "lat": -38.149246,
    "lng": 144.364397,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Geelong%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Geelong West",
    "state": "VIC",
    "lat": -38.141689,
    "lng": 144.347457,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Geelong%20West%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Geelong Westfield",
    "state": "VIC",
    "lat": -38.147548,
    "lng": 144.362528,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Geelong%20Westfield%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Geraldton",
    "state": "WA",
    "lat": -28.773788,
    "lng": 114.609024,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Geraldton%2C%20WA%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Girrawheen",
    "state": "WA",
    "lat": -31.838788,
    "lng": 115.83896,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Girrawheen%2C%20WA%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Gladstone Square",
    "state": "QLD",
    "lat": -23.847508,
    "lng": 151.259464,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Gladstone%20Square%2C%20QLD%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Glen Waverley Kingsway",
    "state": "VIC",
    "lat": -37.879607,
    "lng": 145.16468,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Glen%20Waverley%20Kingsway%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Glenelg",
    "state": "SA",
    "lat": -34.980346,
    "lng": 138.515702,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Glenelg%2C%20SA%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Glenorchy",
    "state": "TAS",
    "lat": -42.833077,
    "lng": 147.276409,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Glenorchy%2C%20TAS%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Glenquarie",
    "state": "NSW",
    "lat": -33.986154,
    "lng": 150.891717,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Glenquarie%2C%20NSW%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Gosnells",
    "state": "WA",
    "lat": -32.069999,
    "lng": 115.999616,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Gosnells%2C%20WA%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Grafton",
    "state": "NSW",
    "lat": -29.690728,
    "lng": 152.933302,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Grafton%2C%20NSW%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Granville",
    "state": "NSW",
    "lat": -33.834267,
    "lng": 151.010845,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Granville%2C%20NSW%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Greensborough",
    "state": "VIC",
    "lat": -37.703945,
    "lng": 145.104179,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Greensborough%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Greensborough Plaza",
    "state": "VIC",
    "lat": -37.702652,
    "lng": 145.102067,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Greensborough%20Plaza%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Griffith",
    "state": "NSW",
    "lat": -34.290616,
    "lng": 146.051306,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Griffith%2C%20NSW%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Griffith - Banna Ave",
    "state": "NSW",
    "lat": -34.290616,
    "lng": 146.051306,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Griffith%20-%20Banna%20Ave%2C%20NSW%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Gympie",
    "state": "QLD",
    "lat": -26.220497,
    "lng": 152.688323,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Gympie%2C%20QLD%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Hamilton",
    "state": "NSW",
    "lat": -32.920961,
    "lng": 151.747201,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Hamilton%2C%20NSW%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Hampton Park",
    "state": "VIC",
    "lat": -38.033821,
    "lng": 145.283535,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Hampton%20Park%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Hawksburn",
    "state": "VIC",
    "lat": -37.848056,
    "lng": 145.003705,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Hawksburn%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Haymarket",
    "state": "NSW",
    "lat": -33.88332,
    "lng": 151.203132,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Haymarket%2C%20NSW%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Heidelberg West",
    "state": "VIC",
    "lat": -37.748807,
    "lng": 145.041005,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Heidelberg%20West%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Helensvale",
    "state": "QLD",
    "lat": -27.886146,
    "lng": 153.318641,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Helensvale%2C%20QLD%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Hervey Bay",
    "state": "QLD",
    "lat": -25.289626,
    "lng": 152.837404,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Hervey%20Bay%2C%20QLD%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Hervey Bay Airport",
    "state": "QLD",
    "lat": -25.323397,
    "lng": 152.892837,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Hervey%20Bay%20Airport%2C%20QLD%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Highpoint",
    "state": "VIC",
    "lat": -37.774969,
    "lng": 144.88788,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Highpoint%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Hillsdale",
    "state": "NSW",
    "lat": -33.951707,
    "lng": 151.23103,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Hillsdale%2C%20NSW%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Hobart",
    "state": "TAS",
    "lat": -42.88216,
    "lng": 147.32891,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Hobart%2C%20TAS%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Hobart City Centre",
    "state": "TAS",
    "lat": -42.88216,
    "lng": 147.32891,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Hobart%20City%20Centre%2C%20TAS%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Home Focus Pimpama",
    "state": "QLD",
    "lat": -27.821645,
    "lng": 153.297108,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Home%20Focus%20Pimpama%2C%20QLD%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Home Gladstone",
    "state": "QLD",
    "lat": -23.877412,
    "lng": 151.226688,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Home%20Gladstone%2C%20QLD%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Hoppers Crossing",
    "state": "VIC",
    "lat": -37.869372,
    "lng": 144.733383,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Hoppers%20Crossing%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Hornsby",
    "state": "NSW",
    "lat": -33.703575,
    "lng": 151.10204,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Hornsby%2C%20NSW%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Hurstville",
    "state": "NSW",
    "lat": -33.966774,
    "lng": 151.104467,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Hurstville%2C%20NSW%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Hurstville Forest Rd",
    "state": "NSW",
    "lat": -33.967022,
    "lng": 151.103344,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Hurstville%20Forest%20Rd%2C%20NSW%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Hyperdome Shopping Centre (Ultra Beauty)",
    "state": "QLD",
    "lat": -27.658594,
    "lng": 153.1696,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Hyperdome%20Shopping%20Centre%20(Ultra%20Beauty)%2C%20QLD%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Inala Plaza Shopping Centre",
    "state": "QLD",
    "lat": -27.597904,
    "lng": 152.973938,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Inala%20Plaza%20Shopping%20Centre%2C%20QLD%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Indooroopilly",
    "state": "QLD",
    "lat": -27.497598,
    "lng": 152.976036,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Indooroopilly%2C%20QLD%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Innaloo",
    "state": "WA",
    "lat": -31.901372,
    "lng": 115.797035,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Innaloo%2C%20WA%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Innisfail",
    "state": "QLD",
    "lat": -17.524497,
    "lng": 146.030464,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Innisfail%2C%20QLD%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Ipswich Central",
    "state": "QLD",
    "lat": -27.616453,
    "lng": 152.761179,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Ipswich%20Central%2C%20QLD%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Ipswich HQ",
    "state": "QLD",
    "lat": -27.619415,
    "lng": 152.747472,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Ipswich%20HQ%2C%20QLD%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Ivanhoe",
    "state": "VIC",
    "lat": -37.76897,
    "lng": 145.041959,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Ivanhoe%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Jindalee Home Shopping Centre",
    "state": "QLD",
    "lat": -27.533225,
    "lng": 152.947754,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Jindalee%20Home%20Shopping%20Centre%2C%20QLD%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Joondalup",
    "state": "WA",
    "lat": -31.743738,
    "lng": 115.763079,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Joondalup%2C%20WA%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Joondalup - Home Co.",
    "state": "WA",
    "lat": -31.756344,
    "lng": 115.770541,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Joondalup%20-%20Home%20Co.%2C%20WA%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Kalkallo",
    "state": "VIC",
    "lat": -37.534621,
    "lng": 144.961186,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Kalkallo%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Kangaroo Flat",
    "state": "VIC",
    "lat": -36.796439,
    "lng": 144.243861,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Kangaroo%20Flat%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Karingal",
    "state": "VIC",
    "lat": -38.154544,
    "lng": 145.166202,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Karingal%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Kedron",
    "state": "QLD",
    "lat": -27.393902,
    "lng": 153.030653,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Kedron%2C%20QLD%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Keilor East",
    "state": "VIC",
    "lat": -37.749092,
    "lng": 144.861734,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Keilor%20East%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Kew",
    "state": "VIC",
    "lat": -37.80714,
    "lng": 145.029462,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Kew%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Keysborough",
    "state": "VIC",
    "lat": -37.99442,
    "lng": 145.172475,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Keysborough%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Keysborough - Home Co.",
    "state": "VIC",
    "lat": -37.992055,
    "lng": 145.146143,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Keysborough%20-%20Home%20Co.%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Kilburn",
    "state": "SA",
    "lat": -34.863567,
    "lng": 138.592034,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Kilburn%2C%20SA%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Kingston Central Plaza",
    "state": "VIC",
    "lat": -37.97064,
    "lng": 145.093781,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Kingston%20Central%20Plaza%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Knoxfield",
    "state": "VIC",
    "lat": -37.876367,
    "lng": 145.256048,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Knoxfield%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Kogarah",
    "state": "NSW",
    "lat": -33.963468,
    "lng": 151.132734,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Kogarah%2C%20NSW%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Koornang Rd",
    "state": "VIC",
    "lat": -37.887348,
    "lng": 145.057305,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Koornang%20Rd%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Kwinana Supa Centre",
    "state": "WA",
    "lat": -32.246901,
    "lng": 115.816545,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Kwinana%20Supa%20Centre%2C%20WA%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Lake Macquarie Fair",
    "state": "NSW",
    "lat": -32.984722,
    "lng": 151.672273,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Lake%20Macquarie%20Fair%2C%20NSW%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Lakemba",
    "state": "NSW",
    "lat": -33.921177,
    "lng": 151.077964,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Lakemba%2C%20NSW%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Lalor",
    "state": "VIC",
    "lat": -37.673843,
    "lng": 145.015971,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Lalor%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Launceston",
    "state": "TAS",
    "lat": -41.438954,
    "lng": 147.138185,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Launceston%2C%20TAS%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Lavington",
    "state": "NSW",
    "lat": -36.033531,
    "lng": 146.950468,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Lavington%2C%20NSW%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Lawnton",
    "state": "QLD",
    "lat": -27.289338,
    "lng": 152.984361,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Lawnton%2C%20QLD%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Leda",
    "state": "WA",
    "lat": -32.259551,
    "lng": 115.805974,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Leda%2C%20WA%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Leichhardt",
    "state": "NSW",
    "lat": -33.882597,
    "lng": 151.157005,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Leichhardt%2C%20NSW%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Liege Street Innaloo",
    "state": "WA",
    "lat": -31.903978,
    "lng": 115.79927,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Liege%20Street%20Innaloo%2C%20WA%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Lilydale",
    "state": "VIC",
    "lat": -37.759802,
    "lng": 145.348739,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Lilydale%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Lindisfarne",
    "state": "TAS",
    "lat": -42.847471,
    "lng": 147.353067,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Lindisfarne%2C%20TAS%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Lismore",
    "state": "NSW",
    "lat": -28.812539,
    "lng": 153.347793,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Lismore%2C%20NSW%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Liverpool",
    "state": "NSW",
    "lat": -33.919223,
    "lng": 150.924814,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Liverpool%2C%20NSW%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Liverpool Westfield",
    "state": "NSW",
    "lat": -33.919223,
    "lng": 150.924814,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Liverpool%20Westfield%2C%20NSW%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Logan",
    "state": "QLD",
    "lat": -27.642487,
    "lng": 153.115987,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Logan%2C%20QLD%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Lower Plenty",
    "state": "VIC",
    "lat": -37.728023,
    "lng": 145.111117,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Lower%20Plenty%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Ludmilla",
    "state": "NT",
    "lat": -12.409602,
    "lng": 130.855691,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Ludmilla%2C%20NT%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Macarthur Square Campbelltown",
    "state": "NSW",
    "lat": -34.073582,
    "lng": 150.797093,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Macarthur%20Square%20Campbelltown%2C%20NSW%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Macgregor",
    "state": "QLD",
    "lat": -27.562973,
    "lng": 153.071737,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Macgregor%2C%20QLD%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Mackay",
    "state": "QLD",
    "lat": -21.140565,
    "lng": 149.178871,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Mackay%2C%20QLD%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Majura Park SC",
    "state": "ACT",
    "lat": -35.298176,
    "lng": 149.190388,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Majura%20Park%20SC%2C%20ACT%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Malvern (Ultra Beauty)",
    "state": "VIC",
    "lat": -37.861382,
    "lng": 145.028706,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Malvern%20(Ultra%20Beauty)%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Manchester Unity",
    "state": "VIC",
    "lat": -37.815482,
    "lng": 144.96614,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Manchester%20Unity%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Mango Hill",
    "state": "QLD",
    "lat": -27.243306,
    "lng": 153.026553,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Mango%20Hill%2C%20QLD%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Manly",
    "state": "NSW",
    "lat": -33.798229,
    "lng": 151.286623,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Manly%2C%20NSW%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Marcoola",
    "state": "QLD",
    "lat": -26.602985,
    "lng": 153.096028,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Marcoola%2C%20QLD%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Maribyrnong",
    "state": "VIC",
    "lat": -37.774969,
    "lng": 144.88788,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Maribyrnong%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Maroochydore",
    "state": "QLD",
    "lat": -26.651507,
    "lng": 153.081469,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Maroochydore%2C%20QLD%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Maroochydore Aerodrome Road",
    "state": "QLD",
    "lat": -26.660216,
    "lng": 153.098535,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Maroochydore%20Aerodrome%20Road%2C%20QLD%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Maroubra",
    "state": "NSW",
    "lat": -33.942014,
    "lng": 151.241072,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Maroubra%2C%20NSW%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Marrara - Northlakes SC",
    "state": "NT",
    "lat": -12.395841,
    "lng": 130.895801,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Marrara%20-%20Northlakes%20SC%2C%20NT%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Marrickville",
    "state": "NSW",
    "lat": -33.911572,
    "lng": 151.155179,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Marrickville%2C%20NSW%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Maryborough",
    "state": "QLD",
    "lat": -25.542877,
    "lng": 152.700242,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Maryborough%2C%20QLD%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Mayfield",
    "state": "NSW",
    "lat": -32.89988,
    "lng": 151.74032,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Mayfield%2C%20NSW%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Melbourne",
    "state": "VIC",
    "lat": -37.816472,
    "lng": 144.956112,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Melbourne%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Melbourne - Bourke & King Street",
    "state": "VIC",
    "lat": -37.816472,
    "lng": 144.956112,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Melbourne%20-%20Bourke%20%26%20King%20Street%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Melbourne - Flinders Street",
    "state": "VIC",
    "lat": -37.817829,
    "lng": 144.965287,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Melbourne%20-%20Flinders%20Street%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Melbourne - William St",
    "state": "VIC",
    "lat": -37.81146,
    "lng": 144.956666,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Melbourne%20-%20William%20St%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Melbourne Central",
    "state": "VIC",
    "lat": -37.811569,
    "lng": 144.963625,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Melbourne%20Central%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Melbourne Midtown Plaza",
    "state": "VIC",
    "lat": -37.813105,
    "lng": 144.965709,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Melbourne%20Midtown%20Plaza%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Melbourne Paramount Centre (Ultra Beauty)",
    "state": "VIC",
    "lat": -37.811894,
    "lng": 144.969874,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Melbourne%20Paramount%20Centre%20(Ultra%20Beauty)%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Melton",
    "state": "VIC",
    "lat": -37.689014,
    "lng": 144.603731,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Melton%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Melton South",
    "state": "VIC",
    "lat": -37.722005,
    "lng": 144.571416,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Melton%20South%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Mentone",
    "state": "VIC",
    "lat": -37.982432,
    "lng": 145.063045,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Mentone%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Mernda",
    "state": "VIC",
    "lat": -37.593896,
    "lng": 145.090344,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Mernda%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Mernda Junction",
    "state": "VIC",
    "lat": -37.600158,
    "lng": 145.095587,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Mernda%20Junction%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Merrifield City SC Mickleham",
    "state": "VIC",
    "lat": -37.536382,
    "lng": 144.920446,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Merrifield%20City%20SC%20Mickleham%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse MidCity Sydney",
    "state": "NSW",
    "lat": -33.869586,
    "lng": 151.207836,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20MidCity%20Sydney%2C%20NSW%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Midland Gate",
    "state": "WA",
    "lat": -31.890453,
    "lng": 116.012871,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Midland%20Gate%2C%20WA%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Midland Military Markets",
    "state": "WA",
    "lat": -31.897046,
    "lng": 116.016604,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Midland%20Military%20Markets%2C%20WA%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Mildura",
    "state": "VIC",
    "lat": -34.186932,
    "lng": 142.15876,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Mildura%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Mildura Central Shopping Centre",
    "state": "VIC",
    "lat": -34.207656,
    "lng": 142.139592,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Mildura%20Central%20Shopping%20Centre%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Mildura DC",
    "state": "VIC",
    "lat": -34.218096,
    "lng": 142.149375,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Mildura%20DC%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Miranda",
    "state": "NSW",
    "lat": -34.033932,
    "lng": 151.101207,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Miranda%2C%20NSW%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Mirrabooka",
    "state": "WA",
    "lat": -31.870206,
    "lng": 115.856197,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Mirrabooka%2C%20WA%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Mirrabooka Square",
    "state": "WA",
    "lat": -31.87091,
    "lng": 115.862071,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Mirrabooka%20Square%2C%20WA%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Moana",
    "state": "SA",
    "lat": -35.213828,
    "lng": 138.478166,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Moana%2C%20SA%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Modbury",
    "state": "SA",
    "lat": -34.831932,
    "lng": 138.686996,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Modbury%2C%20SA%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Modbury Triangle SC",
    "state": "SA",
    "lat": -34.831932,
    "lng": 138.686996,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Modbury%20Triangle%20SC%2C%20SA%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Moonah",
    "state": "TAS",
    "lat": -42.847029,
    "lng": 147.295036,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Moonah%2C%20TAS%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Moonee Ponds",
    "state": "VIC",
    "lat": -37.766588,
    "lng": 144.921799,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Moonee%20Ponds%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Moorabbin",
    "state": "VIC",
    "lat": -37.933795,
    "lng": 145.034582,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Moorabbin%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Moorabbin Super Centre, Heatherton",
    "state": "VIC",
    "lat": -37.947313,
    "lng": 145.079504,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Moorabbin%20Super%20Centre%2C%20Heatherton%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Morley Coventry Village",
    "state": "WA",
    "lat": -31.894835,
    "lng": 115.895001,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Morley%20Coventry%20Village%2C%20WA%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Mornington",
    "state": "VIC",
    "lat": -38.237913,
    "lng": 145.063961,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Mornington%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Mornington Central (Ultra Beauty)",
    "state": "VIC",
    "lat": -38.218739,
    "lng": 145.039519,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Mornington%20Central%20(Ultra%20Beauty)%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Mortdale",
    "state": "NSW",
    "lat": -33.970362,
    "lng": 151.08033,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Mortdale%2C%20NSW%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Morwell",
    "state": "VIC",
    "lat": -38.241154,
    "lng": 146.420244,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Morwell%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Mosman",
    "state": "NSW",
    "lat": -33.830657,
    "lng": 151.244607,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Mosman%2C%20NSW%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Mount Cotton",
    "state": "QLD",
    "lat": -27.638619,
    "lng": 153.248403,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Mount%20Cotton%2C%20QLD%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Mount Waverley",
    "state": "VIC",
    "lat": -37.876527,
    "lng": 145.127298,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Mount%20Waverley%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Mowbray",
    "state": "TAS",
    "lat": -41.405787,
    "lng": 147.13527,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Mowbray%2C%20TAS%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Mt Gravatt",
    "state": "QLD",
    "lat": -27.530462,
    "lng": 153.073266,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Mt%20Gravatt%2C%20QLD%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Mudgee",
    "state": "NSW",
    "lat": -32.592519,
    "lng": 149.587104,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Mudgee%2C%20NSW%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Munno Para",
    "state": "SA",
    "lat": -34.692578,
    "lng": 138.687103,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Munno%20Para%2C%20SA%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Murray Bridge",
    "state": "SA",
    "lat": -35.12835,
    "lng": 139.252189,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Murray%20Bridge%2C%20SA%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Muswellbrook",
    "state": "NSW",
    "lat": -32.282716,
    "lng": 150.896452,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Muswellbrook%2C%20NSW%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Nambour",
    "state": "QLD",
    "lat": -26.626851,
    "lng": 152.961045,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Nambour%2C%20QLD%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Nerang",
    "state": "QLD",
    "lat": -27.995663,
    "lng": 153.339075,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Nerang%2C%20QLD%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Neutral Bay",
    "state": "NSW",
    "lat": -33.830908,
    "lng": 151.221078,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Neutral%20Bay%2C%20NSW%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse New Town TAS",
    "state": "TAS",
    "lat": -42.855982,
    "lng": 147.305876,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20New%20Town%20TAS%2C%20TAS%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Newbrook Shopping Village Airds",
    "state": "NSW",
    "lat": -34.084223,
    "lng": 150.828501,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Newbrook%20Shopping%20Village%20Airds%2C%20NSW%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Newcastle",
    "state": "NSW",
    "lat": -32.92704,
    "lng": 151.781884,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Newcastle%2C%20NSW%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Newmarket",
    "state": "VIC",
    "lat": -37.787327,
    "lng": 144.927876,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Newmarket%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Newnham",
    "state": "TAS",
    "lat": -41.389213,
    "lng": 147.126384,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Newnham%2C%20TAS%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Newpark Shopping Centre",
    "state": "WA",
    "lat": -31.835743,
    "lng": 115.829611,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Newpark%20Shopping%20Centre%2C%20WA%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Newtown NSW",
    "state": "NSW",
    "lat": -33.895857,
    "lng": 151.181492,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Newtown%20NSW%2C%20NSW%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Niddrie",
    "state": "VIC",
    "lat": -37.737462,
    "lng": 144.893624,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Niddrie%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Noble Park",
    "state": "VIC",
    "lat": -37.967896,
    "lng": 145.175866,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Noble%20Park%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse North Hobart",
    "state": "TAS",
    "lat": -42.874407,
    "lng": 147.316228,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20North%20Hobart%2C%20TAS%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse North Mackay",
    "state": "QLD",
    "lat": -21.126618,
    "lng": 149.188568,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20North%20Mackay%2C%20QLD%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse North Melbourne",
    "state": "VIC",
    "lat": -37.804527,
    "lng": 144.949004,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20North%20Melbourne%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse North Parramatta",
    "state": "NSW",
    "lat": -33.805792,
    "lng": 151.005997,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20North%20Parramatta%2C%20NSW%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse North Perth",
    "state": "WA",
    "lat": -31.932202,
    "lng": 115.859508,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20North%20Perth%2C%20WA%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse North Rockhampton",
    "state": "QLD",
    "lat": -23.356655,
    "lng": 150.518923,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20North%20Rockhampton%2C%20QLD%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse North Sydney",
    "state": "NSW",
    "lat": -33.839328,
    "lng": 151.208453,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20North%20Sydney%2C%20NSW%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Northbridge",
    "state": "WA",
    "lat": -31.94548,
    "lng": 115.861452,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Northbridge%2C%20WA%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Northcote",
    "state": "VIC",
    "lat": -37.769417,
    "lng": 144.998614,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Northcote%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Northfield",
    "state": "SA",
    "lat": -34.851608,
    "lng": 138.617934,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Northfield%2C%20SA%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Northgate Shopping Centre",
    "state": "TAS",
    "lat": -42.832495,
    "lng": 147.273047,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Northgate%20Shopping%20Centre%2C%20TAS%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Northlakes - Home Co.",
    "state": "QLD",
    "lat": -27.240042,
    "lng": 153.012359,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Northlakes%20-%20Home%20Co.%2C%20QLD%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Northland",
    "state": "VIC",
    "lat": -37.739899,
    "lng": 145.028249,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Northland%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Norwood",
    "state": "SA",
    "lat": -34.921359,
    "lng": 138.63726,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Norwood%2C%20SA%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Nowra",
    "state": "NSW",
    "lat": -34.874359,
    "lng": 150.601404,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Nowra%2C%20NSW%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Nowra Junction Street",
    "state": "NSW",
    "lat": -34.874359,
    "lng": 150.601404,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Nowra%20Junction%20Street%2C%20NSW%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Oakleigh",
    "state": "VIC",
    "lat": -37.900041,
    "lng": 145.090022,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Oakleigh%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Ocean Keys Shopping Centre",
    "state": "WA",
    "lat": -31.691237,
    "lng": 115.717946,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Ocean%20Keys%20Shopping%20Centre%2C%20WA%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse O'Connor",
    "state": "WA",
    "lat": -30.775621,
    "lng": 121.460727,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20O'Connor%2C%20WA%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Old South Head Rose Bay",
    "state": "NSW",
    "lat": -33.874544,
    "lng": 151.273045,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Old%20South%20Head%20Rose%20Bay%2C%20NSW%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Orange (Ultra Beauty)",
    "state": "NSW",
    "lat": -33.283444,
    "lng": 149.097109,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Orange%20(Ultra%20Beauty)%2C%20NSW%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Ormeau",
    "state": "QLD",
    "lat": -27.784872,
    "lng": 153.250994,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Ormeau%2C%20QLD%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Oxley",
    "state": "QLD",
    "lat": -27.576115,
    "lng": 152.982928,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Oxley%2C%20QLD%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Pacific Epping SC",
    "state": "VIC",
    "lat": -37.655199,
    "lng": 145.022728,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Pacific%20Epping%20SC%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Pacific Werribee SC",
    "state": "VIC",
    "lat": -37.875766,
    "lng": 144.679421,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Pacific%20Werribee%20SC%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Pakenham",
    "state": "VIC",
    "lat": -38.08553,
    "lng": 145.471031,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Pakenham%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Pakenham Main Street",
    "state": "VIC",
    "lat": -38.07875,
    "lng": 145.483127,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Pakenham%20Main%20Street%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Parabanks SC Salisbury",
    "state": "SA",
    "lat": -34.76135,
    "lng": 138.64686,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Parabanks%20SC%20Salisbury%2C%20SA%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Parramatta",
    "state": "NSW",
    "lat": -33.814845,
    "lng": 151.003221,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Parramatta%2C%20NSW%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Pennant Hills",
    "state": "NSW",
    "lat": -33.738468,
    "lng": 151.070603,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Pennant%20Hills%2C%20NSW%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Penrith Central",
    "state": "NSW",
    "lat": -33.753195,
    "lng": 150.696931,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Penrith%20Central%2C%20NSW%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Penrith Distribution Centre",
    "state": "NSW",
    "lat": -33.769212,
    "lng": 150.66971,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Penrith%20Distribution%20Centre%2C%20NSW%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Penrith Plaza",
    "state": "NSW",
    "lat": -33.75125,
    "lng": 150.695431,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Penrith%20Plaza%2C%20NSW%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Perth",
    "state": "WA",
    "lat": -31.953997,
    "lng": 115.86198,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Perth%2C%20WA%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Perth City Centre",
    "state": "WA",
    "lat": -31.953997,
    "lng": 115.86198,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Perth%20City%20Centre%2C%20WA%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Piara Waters",
    "state": "WA",
    "lat": -32.116763,
    "lng": 115.915904,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Piara%20Waters%2C%20WA%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Pimpama City Shopping Centre",
    "state": "QLD",
    "lat": -27.813989,
    "lng": 153.293295,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Pimpama%20City%20Shopping%20Centre%2C%20QLD%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Point Cook",
    "state": "VIC",
    "lat": -37.893148,
    "lng": 144.728593,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Point%20Cook%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Polaris",
    "state": "VIC",
    "lat": -37.712384,
    "lng": 145.048524,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Polaris%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Port Adelaide",
    "state": "SA",
    "lat": -34.845393,
    "lng": 138.504222,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Port%20Adelaide%2C%20SA%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Port Central SC",
    "state": "NSW",
    "lat": -31.429888,
    "lng": 152.90908,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Port%20Central%20SC%2C%20NSW%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Port Macquarie Gordon St",
    "state": "NSW",
    "lat": -31.434805,
    "lng": 152.905928,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Port%20Macquarie%20Gordon%20St%2C%20NSW%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Port Melbourne",
    "state": "VIC",
    "lat": -37.837091,
    "lng": 144.943483,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Port%20Melbourne%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Prahran",
    "state": "VIC",
    "lat": -37.846238,
    "lng": 144.994372,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Prahran%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Preston",
    "state": "VIC",
    "lat": -37.753043,
    "lng": 145.02117,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Preston%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Preston - Home Co. DC",
    "state": "VIC",
    "lat": -37.744736,
    "lng": 145.029772,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Preston%20-%20Home%20Co.%20DC%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Pullenvale",
    "state": "QLD",
    "lat": -27.52978,
    "lng": 152.909671,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Pullenvale%2C%20QLD%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Punchbowl",
    "state": "NSW",
    "lat": -33.92581,
    "lng": 151.058145,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Punchbowl%2C%20NSW%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Queanbeyan",
    "state": "NSW",
    "lat": -35.347966,
    "lng": 149.246918,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Queanbeyan%2C%20NSW%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Racecourse Launceston",
    "state": "TAS",
    "lat": -41.429669,
    "lng": 147.146539,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Racecourse%20Launceston%2C%20TAS%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Randwick",
    "state": "NSW",
    "lat": -33.916938,
    "lng": 151.240859,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Randwick%2C%20NSW%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Randwick - Alison Road",
    "state": "NSW",
    "lat": -33.912805,
    "lng": 151.239084,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Randwick%20-%20Alison%20Road%2C%20NSW%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Redcliffe",
    "state": "QLD",
    "lat": -27.226025,
    "lng": 153.114523,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Redcliffe%2C%20QLD%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Redland",
    "state": "QLD",
    "lat": -27.541879,
    "lng": 153.250424,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Redland%2C%20QLD%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Reservoir Central SC",
    "state": "VIC",
    "lat": -37.725725,
    "lng": 145.02686,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Reservoir%20Central%20SC%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Richmond",
    "state": "VIC",
    "lat": -37.818585,
    "lng": 145.001264,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Richmond%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Ringwood",
    "state": "VIC",
    "lat": -37.815851,
    "lng": 145.226854,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Ringwood%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Ringwood Lake",
    "state": "VIC",
    "lat": -37.812069,
    "lng": 145.235378,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Ringwood%20Lake%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Riverside Plaza",
    "state": "VIC",
    "lat": -36.408679,
    "lng": 145.392156,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Riverside%20Plaza%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Robinson Road Marketplace Aspley",
    "state": "QLD",
    "lat": -27.364715,
    "lng": 153.024313,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Robinson%20Road%20Marketplace%20Aspley%2C%20QLD%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Rockdale Plaza",
    "state": "NSW",
    "lat": -33.958209,
    "lng": 151.140121,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Rockdale%20Plaza%2C%20NSW%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Rockhampton",
    "state": "QLD",
    "lat": -23.377037,
    "lng": 150.512762,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Rockhampton%2C%20QLD%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Rockingham Centre",
    "state": "WA",
    "lat": -32.289574,
    "lng": 115.744946,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Rockingham%20Centre%2C%20WA%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Rockingham Robinson Road",
    "state": "WA",
    "lat": -32.287317,
    "lng": 115.7409,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Rockingham%20Robinson%20Road%2C%20WA%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Rocklea",
    "state": "QLD",
    "lat": -27.536146,
    "lng": 153.000003,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Rocklea%2C%20QLD%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Rooty Hill",
    "state": "NSW",
    "lat": -33.770667,
    "lng": 150.843448,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Rooty%20Hill%2C%20NSW%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Rosanna",
    "state": "VIC",
    "lat": -37.742747,
    "lng": 145.064692,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Rosanna%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Rose Bay 2",
    "state": "NSW",
    "lat": -33.870448,
    "lng": 151.27015,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Rose%20Bay%202%2C%20NSW%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Rosny",
    "state": "TAS",
    "lat": -42.863885,
    "lng": 147.371182,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Rosny%2C%20TAS%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Roxburgh Park - Home Co.",
    "state": "VIC",
    "lat": -37.63997,
    "lng": 144.932065,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Roxburgh%20Park%20-%20Home%20Co.%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Roxburgh Village",
    "state": "VIC",
    "lat": -37.63997,
    "lng": 144.932065,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Roxburgh%20Village%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Safety Beach",
    "state": "VIC",
    "lat": -38.311259,
    "lng": 144.993372,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Safety%20Beach%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Saints SC Salisbury Plains",
    "state": "SA",
    "lat": -34.766159,
    "lng": 138.667498,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Saints%20SC%20Salisbury%20Plains%2C%20SA%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Salamanca",
    "state": "TAS",
    "lat": -42.887578,
    "lng": 147.331577,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Salamanca%2C%20TAS%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Sale",
    "state": "VIC",
    "lat": -38.106729,
    "lng": 147.065876,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Sale%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Salisbury",
    "state": "SA",
    "lat": -34.76135,
    "lng": 138.64686,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Salisbury%2C%20SA%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Sandgate",
    "state": "QLD",
    "lat": -27.31904,
    "lng": 153.069079,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Sandgate%2C%20QLD%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Sandy Bay",
    "state": "TAS",
    "lat": -42.89519,
    "lng": 147.327029,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Sandy%20Bay%2C%20TAS%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Seaford Meadows",
    "state": "SA",
    "lat": -35.172486,
    "lng": 138.48341,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Seaford%20Meadows%2C%20SA%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Sebastopol",
    "state": "VIC",
    "lat": -37.591485,
    "lng": 143.840688,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Sebastopol%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Sefton Plaza",
    "state": "SA",
    "lat": -34.8756,
    "lng": 138.602978,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Sefton%20Plaza%2C%20SA%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Shailer Park",
    "state": "QLD",
    "lat": -27.662871,
    "lng": 153.17897,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Shailer%20Park%2C%20QLD%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Shellharbour",
    "state": "NSW",
    "lat": -34.566477,
    "lng": 150.829366,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Shellharbour%2C%20NSW%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Shepparton",
    "state": "VIC",
    "lat": -36.383481,
    "lng": 145.399525,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Shepparton%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Shepparton North",
    "state": "VIC",
    "lat": -36.356959,
    "lng": 145.402486,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Shepparton%20North%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Singleton",
    "state": "WA",
    "lat": -32.44787,
    "lng": 115.764691,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Singleton%2C%20WA%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Smithfield",
    "state": "SA",
    "lat": -34.692578,
    "lng": 138.687103,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Smithfield%2C%20SA%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Sorell",
    "state": "TAS",
    "lat": -42.781932,
    "lng": 147.562947,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Sorell%2C%20TAS%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse South Launceston",
    "state": "TAS",
    "lat": -41.443276,
    "lng": 147.138193,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20South%20Launceston%2C%20TAS%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse South Melbourne",
    "state": "VIC",
    "lat": -37.833802,
    "lng": 144.960724,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20South%20Melbourne%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse South Wharf DFO (Ultra Beauty)",
    "state": "VIC",
    "lat": -37.825305,
    "lng": 144.948584,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20South%20Wharf%20DFO%20(Ultra%20Beauty)%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse South Yarra",
    "state": "VIC",
    "lat": -37.846238,
    "lng": 144.994372,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20South%20Yarra%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Southbank",
    "state": "VIC",
    "lat": -37.828769,
    "lng": 144.965487,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Southbank%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Southern River",
    "state": "WA",
    "lat": -32.100718,
    "lng": 115.965397,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Southern%20River%2C%20WA%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Southport",
    "state": "QLD",
    "lat": -27.968425,
    "lng": 153.414622,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Southport%2C%20QLD%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Southport Brickworks Centre",
    "state": "QLD",
    "lat": -27.97953,
    "lng": 153.409423,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Southport%20Brickworks%20Centre%2C%20QLD%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Spencer Outlet Centre",
    "state": "VIC",
    "lat": -37.815198,
    "lng": 144.951793,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Spencer%20Outlet%20Centre%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Spotswood",
    "state": "VIC",
    "lat": -37.832231,
    "lng": 144.882024,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Spotswood%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Springvale",
    "state": "VIC",
    "lat": -37.953014,
    "lng": 145.151966,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Springvale%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Springvale Mega Centre",
    "state": "VIC",
    "lat": -37.941516,
    "lng": 145.167617,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Springvale%20Mega%20Centre%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse St Albans",
    "state": "VIC",
    "lat": -37.744493,
    "lng": 144.800909,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20St%20Albans%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse St Kilda - Acland Street",
    "state": "VIC",
    "lat": -37.869118,
    "lng": 144.979902,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20St%20Kilda%20-%20Acland%20Street%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse St Kilda - Fitzroy Street",
    "state": "VIC",
    "lat": -37.861528,
    "lng": 144.974792,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20St%20Kilda%20-%20Fitzroy%20Street%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse St Marys",
    "state": "NSW",
    "lat": -33.765143,
    "lng": 150.774457,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20St%20Marys%2C%20NSW%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Stirling Central Shopping Centre",
    "state": "WA",
    "lat": -31.862485,
    "lng": 115.828808,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Stirling%20Central%20Shopping%20Centre%2C%20WA%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Strathfield Plaza",
    "state": "NSW",
    "lat": -33.873225,
    "lng": 151.093107,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Strathfield%20Plaza%2C%20NSW%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Strathpine",
    "state": "NSW",
    "lat": -27.30608,
    "lng": 152.98854,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Strathpine%2C%20NSW%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Subiaco",
    "state": "WA",
    "lat": -31.948137,
    "lng": 115.823866,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Subiaco%2C%20WA%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Sunbury",
    "state": "VIC",
    "lat": -37.57795,
    "lng": 144.713411,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Sunbury%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Sunbury Gap Rd",
    "state": "VIC",
    "lat": -37.57795,
    "lng": 144.713411,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Sunbury%20Gap%20Rd%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Sunnybank Plaza",
    "state": "QLD",
    "lat": -27.569962,
    "lng": 153.062826,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Sunnybank%20Plaza%2C%20QLD%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Sunshine",
    "state": "VIC",
    "lat": -37.784097,
    "lng": 144.832589,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Sunshine%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Surry Hills",
    "state": "NSW",
    "lat": -33.891596,
    "lng": 151.212752,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Surry%20Hills%2C%20NSW%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Swan Street Richmond",
    "state": "VIC",
    "lat": -37.825623,
    "lng": 144.996434,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Swan%20Street%20Richmond%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Sydney - George Street",
    "state": "NSW",
    "lat": -33.869365,
    "lng": 151.206631,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Sydney%20-%20George%20Street%2C%20NSW%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Sydney - Park Street",
    "state": "NSW",
    "lat": -33.872587,
    "lng": 151.207584,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Sydney%20-%20Park%20Street%2C%20NSW%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Sydney - Pitt St North (Ultra Beauty)",
    "state": "NSW",
    "lat": -33.866634,
    "lng": 151.208922,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Sydney%20-%20Pitt%20St%20North%20(Ultra%20Beauty)%2C%20NSW%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Sydney Central",
    "state": "NSW",
    "lat": -33.875824,
    "lng": 151.206495,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Sydney%20Central%2C%20NSW%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Sydney Hyde Park",
    "state": "NSW",
    "lat": -33.876621,
    "lng": 151.209282,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Sydney%20Hyde%20Park%2C%20NSW%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Sydney Olympic Park",
    "state": "NSW",
    "lat": -33.846015,
    "lng": 151.06945,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Sydney%20Olympic%20Park%2C%20NSW%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Sydney Pitt St",
    "state": "NSW",
    "lat": -33.87139,
    "lng": 151.207887,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Sydney%20Pitt%20St%2C%20NSW%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Tamworth",
    "state": "NSW",
    "lat": -31.091749,
    "lng": 150.930125,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Tamworth%2C%20NSW%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Tamworth Central",
    "state": "NSW",
    "lat": -31.091749,
    "lng": 150.930125,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Tamworth%20Central%2C%20NSW%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Taree",
    "state": "NSW",
    "lat": -31.911561,
    "lng": 152.460336,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Taree%2C%20NSW%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Tarneit Gardens SC",
    "state": "VIC",
    "lat": -37.839624,
    "lng": 144.674768,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Tarneit%20Gardens%20SC%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Tea Tree Plaza",
    "state": "SA",
    "lat": -34.831183,
    "lng": 138.692956,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Tea%20Tree%20Plaza%2C%20SA%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Templestowe",
    "state": "VIC",
    "lat": -37.757581,
    "lng": 145.129954,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Templestowe%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse The Avenue Cranbourne North",
    "state": "VIC",
    "lat": -38.086505,
    "lng": 145.31687,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20The%20Avenue%20Cranbourne%20North%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse The Glen Shopping Centre (Ultra Beauty)",
    "state": "VIC",
    "lat": -37.875023,
    "lng": 145.165088,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20The%20Glen%20Shopping%20Centre%20(Ultra%20Beauty)%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse The Grove Liverpool",
    "state": "NSW",
    "lat": -33.908366,
    "lng": 150.919548,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20The%20Grove%20Liverpool%2C%20NSW%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse The Links SC Oakleigh South",
    "state": "VIC",
    "lat": -37.921869,
    "lng": 145.083265,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20The%20Links%20SC%20Oakleigh%20South%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Thomastown",
    "state": "VIC",
    "lat": -37.679001,
    "lng": 145.013815,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Thomastown%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Tingalpa",
    "state": "QLD",
    "lat": -27.466483,
    "lng": 153.141075,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Tingalpa%2C%20QLD%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Toowong",
    "state": "QLD",
    "lat": -27.485643,
    "lng": 152.991005,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Toowong%2C%20QLD%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Toowoomba",
    "state": "QLD",
    "lat": -27.560319,
    "lng": 151.952162,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Toowoomba%2C%20QLD%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Torrensville (Ultra Beauty)",
    "state": "SA",
    "lat": -34.923785,
    "lng": 138.563946,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Torrensville%20(Ultra%20Beauty)%2C%20SA%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Townsville",
    "state": "QLD",
    "lat": -19.259369,
    "lng": 146.815502,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Townsville%2C%20QLD%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Traralgon",
    "state": "VIC",
    "lat": -38.195953,
    "lng": 146.538268,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Traralgon%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Truganina Central",
    "state": "VIC",
    "lat": -37.820736,
    "lng": 144.721163,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Truganina%20Central%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Tunstall Square",
    "state": "VIC",
    "lat": -37.790706,
    "lng": 145.172025,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Tunstall%20Square%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Turramurra",
    "state": "NSW",
    "lat": -33.732501,
    "lng": 151.126842,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Turramurra%2C%20NSW%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Underwood",
    "state": "QLD",
    "lat": -27.613727,
    "lng": 153.121245,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Underwood%2C%20QLD%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Upper Queen Street Brisbane",
    "state": "QLD",
    "lat": -27.470123,
    "lng": 153.024137,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Upper%20Queen%20Street%20Brisbane%2C%20QLD%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Varsity Lakes",
    "state": "QLD",
    "lat": -28.085482,
    "lng": 153.424307,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Varsity%20Lakes%2C%20QLD%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Victoria Gardens Shopping Centre",
    "state": "VIC",
    "lat": -37.812436,
    "lng": 145.010376,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Victoria%20Gardens%20Shopping%20Centre%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Victoria Park",
    "state": "WA",
    "lat": -31.97341,
    "lng": 115.896833,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Victoria%20Park%2C%20WA%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Victoria Point",
    "state": "QLD",
    "lat": -27.585883,
    "lng": 153.278393,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Victoria%20Point%2C%20QLD%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Virginia",
    "state": "QLD",
    "lat": -27.375371,
    "lng": 153.062085,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Virginia%2C%20QLD%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Wangaratta DC",
    "state": "VIC",
    "lat": -36.373671,
    "lng": 146.288366,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Wangaratta%20DC%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Warrnambool",
    "state": "VIC",
    "lat": -38.382507,
    "lng": 142.484219,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Warrnambool%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Warrnambool Central",
    "state": "VIC",
    "lat": -38.382507,
    "lng": 142.484219,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Warrnambool%20Central%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Watergardens TC",
    "state": "VIC",
    "lat": -37.696766,
    "lng": 144.776076,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Watergardens%20TC%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Watsonia",
    "state": "VIC",
    "lat": -37.708651,
    "lng": 145.082792,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Watsonia%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Werribee Heaths Road",
    "state": "VIC",
    "lat": -37.877033,
    "lng": 144.675473,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Werribee%20Heaths%20Road%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Werribee Watton Street",
    "state": "VIC",
    "lat": -37.901398,
    "lng": 144.661511,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Werribee%20Watton%20Street%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Westfield Fountain Gate",
    "state": "VIC",
    "lat": -38.018498,
    "lng": 145.305166,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Westfield%20Fountain%20Gate%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Westfield Hornsby",
    "state": "NSW",
    "lat": -33.705134,
    "lng": 151.100478,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Westfield%20Hornsby%2C%20NSW%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Westfield Knox",
    "state": "VIC",
    "lat": -37.870563,
    "lng": 145.242367,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Westfield%20Knox%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Westfield North Lakes East",
    "state": "QLD",
    "lat": -27.242327,
    "lng": 153.018212,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Westfield%20North%20Lakes%20East%2C%20QLD%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Westfield Parramatta",
    "state": "NSW",
    "lat": -33.817689,
    "lng": 151.002038,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Westfield%20Parramatta%2C%20NSW%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Westfield Plenty Valley",
    "state": "VIC",
    "lat": -37.651203,
    "lng": 145.073303,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Westfield%20Plenty%20Valley%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Westfield West Lakes",
    "state": "SA",
    "lat": -34.878982,
    "lng": 138.49094,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Westfield%20West%20Lakes%2C%20SA%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Whitehorse Box Hill",
    "state": "VIC",
    "lat": -37.818342,
    "lng": 145.122881,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Whitehorse%20Box%20Hill%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Whitford",
    "state": "WA",
    "lat": -31.796334,
    "lng": 115.748783,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Whitford%2C%20WA%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Windsor",
    "state": "QLD",
    "lat": -27.436906,
    "lng": 153.030763,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Windsor%2C%20QLD%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Windsor Home Zone Centre",
    "state": "QLD",
    "lat": -27.437193,
    "lng": 153.02329,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Windsor%20Home%20Zone%20Centre%2C%20QLD%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Woden",
    "state": "ACT",
    "lat": -35.345369,
    "lng": 149.083821,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Woden%2C%20ACT%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Wodonga",
    "state": "VIC",
    "lat": -36.122275,
    "lng": 146.888369,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Wodonga%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Wodonga Plaza",
    "state": "VIC",
    "lat": -36.120729,
    "lng": 146.881645,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Wodonga%20Plaza%2C%20VIC%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Wollongong",
    "state": "NSW",
    "lat": -34.423905,
    "lng": 150.892842,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Wollongong%2C%20NSW%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Wollongong Central",
    "state": "NSW",
    "lat": -34.423905,
    "lng": 150.892842,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Wollongong%20Central%2C%20NSW%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Woodville Gardens",
    "state": "SA",
    "lat": -34.869333,
    "lng": 138.548247,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Woodville%20Gardens%2C%20SA%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Woolloongabba",
    "state": "QLD",
    "lat": -27.49021,
    "lng": 153.035786,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Woolloongabba%2C%20QLD%2C%20Australia"
  },
  {
    "name": "Chemist Warehouse Wynnum",
    "state": "QLD",
    "lat": -27.446068,
    "lng": 153.17219,
    "directionsLink": "https://www.google.com/maps/dir/?api=1&destination=Chemist%20Warehouse%20Wynnum%2C%20QLD%2C%20Australia"
  }
];
